import BaseView from '../../../core/baseView';
import * as lightbox from '../../../../home24/helpers/lightbox';

/**
 * @abstract
 */

export default BaseView.extend({
  /**
   * @param {String} lightboxName
   * @param {Function} [onOpenCallback]
   * @param {Function} [onCloseCallback]
   */
  openLightboxByName: function(lightboxName, onOpenCallback, onCloseCallback) {
    var lightboxOptions = this.lightboxesConfig[lightboxName];

    lightboxOptions.onOpenCallback = onOpenCallback;
    lightboxOptions.onCloseCallback = onCloseCallback;

    this.openLightboxUsingOptions(lightboxOptions);
  },

  /**
   * @param {Object} lightboxOptions
   */

  openLightboxUsingOptions: function(lightboxOptions) {
    var lightBoxView;

    var onOpen = function() {
      lightBoxView = this.createLightboxView(lightboxOptions.viewClass);

      if (lightboxOptions.onOpenCallback) {
        lightboxOptions.onOpenCallback.call(this);
      }
    };

    var onClose = function() {
      if (lightBoxView) {
        lightBoxView.destroy();
      }

      if (lightboxOptions.onCloseCallback) {
        lightboxOptions.onCloseCallback.call(this);
      }
    };

    lightbox
      .close()
      .setConfig({
        $dialog: $(lightboxOptions.selector),
        className: lightboxOptions.className,
        onOpen: lightboxOptions.viewClass ? $.proxy(onOpen, this) : null,
        onClose: lightboxOptions.viewClass ? $.proxy(onClose, this) : null
      })
      .open();
  },

  /**
   * Creates view specially for handling actions inside lightbox
   *
   * @param {Function} ViewClass
   */
  createLightboxView: function(ViewClass) {
    var result;

    if (ViewClass) {
      result = new ViewClass({
        el: lightbox.getContent()
      });
    }

    return result;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/BaseView.js
 **/